import PosthogService from '~/services/posthog/PosthogService';

export interface ICampaignUtmViewedPayload {
  source: string;
  campaign: string;
  medium: string;
}

/**
 * Fires once per session when a user lands via a UTM-tagged campaign link
 * Event: dental_portal:campaign:utm_viewed
 */
export function fireCampaignUtmViewed(payload: ICampaignUtmViewedPayload): void {
  PosthogService.getInstance().track('dental_portal:campaign:utm_viewed', {
    source: payload.source,
    campaign: payload.campaign,
    medium: payload.medium,
  });
}
